import { Box, CircularProgress, Typography } from '@mui/material'
import React from 'react'
import { ScrollRestore } from 'src/Libs/flow/components/ScrollRestore'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useInstallation } from 'src/Libs/flow/installation/hooks'
import { EMobilityChargingSessions } from './EMobilityChargingSessions'
import { EMobilityPageSkeleton } from './EMobilityPageSkeleton'
import { useChargingSessions } from './hooks/use-charging-sessions'
import { useParams } from 'react-router-dom'

const EMobilityPage: React.FC = () => {
  const { t } = useCustomTranslation()
  const { installationId } = useParams<{ installationId: string }>()

  if (!installationId) {
    return (
      <Box p={2} pt={6}>
        <Typography align="center" variant="h3" component={'p'}>
          {t('dashboard.noAssociatedInstallation')}
        </Typography>
      </Box>
    )
  }

  return <EMobilityPageStorageIdFetch installationId={Number(installationId)} />
}
export default EMobilityPage

const EMobilityPageStorageIdFetch: React.FC<{
  installationId: number
}> = ({ installationId }) => {
  const { t } = useCustomTranslation()

  const { data, isLoading } = useInstallation(installationId)
  const storageId = data?.emsMasterDeviceId ?? ''

  if (isLoading || !data)
    return (
      <Box display={'flex'} justifyContent={'center'} pt={'30dvh'}>
        <CircularProgress sx={{ m: 'auto' }} />
      </Box>
    )

  if (!storageId) {
    return (
      <Box p={2} pt={6}>
        <Typography align="center" variant="h3" component={'p'}>
          {t('dashboard.noActiveInstallation')}
        </Typography>
      </Box>
    )
  }

  return <EMobilityPageChargingSessionsFetch installationId={installationId} storageId={storageId} />
}

interface EMobilityPageChargingSessionsFetchProps {
  installationId: number
  storageId: string
}
const EMobilityPageChargingSessionsFetch: React.FC<EMobilityPageChargingSessionsFetchProps> = ({ installationId, storageId }) => {
  const { chargingSessions, wallboxes, isLoading, displayEnergyAll } = useChargingSessions(installationId, storageId)

  if (isLoading || !chargingSessions || !wallboxes) return <EMobilityPageSkeleton />

  return (
    <>
      <EMobilityChargingSessions
        installationId={installationId}
        storageId={storageId}
        chargingSessions={chargingSessions}
        displayEnergyAll={displayEnergyAll}
      />
      <ScrollRestore />
    </>
  )
}
